import { schema } from 'normalizr';
import { MentoringProgramEnrollment } from '../models/mentoring-program-enrollments';
import { MentorQuestionAnswer } from 'redux/actions/mentoring-program-participant-driven';

export const MentoringProgramParticipantDrivenMentorSchema = new schema.Entity<MentoringProgramEnrollment>('mentoringProgramParticipantDrivenMentors');

export const MentoringProgramParticipantDrivenMentorsSchema = new schema.Array(MentoringProgramParticipantDrivenMentorSchema);

export const MentoringProgramParticipantDrivenMentorFilterSchema = new schema.Entity<MentorQuestionAnswer>('mentorsFilters');

export const MentoringProgramParticipantDrivenMentorFiltersSchema = new schema.Array(MentoringProgramParticipantDrivenMentorFilterSchema);
